import {registerTemplateGraphNode} from "#template/template-node/register"
import {meshGeometryAttributeLike, meshGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {MeshGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {GetAttributeComponentParameters} from "#template/nodes/geometry-graph/attribute/get-attribute-component/geometry-get-attribute-component-node"
import {
    GeometryGetAttributeComponentNode,
    getAttributeComponentParametersSchema,
} from "#template/nodes/geometry-graph/attribute/get-attribute-component/geometry-get-attribute-component-node"

export type MeshGeometryGetAttributeComponentParameters = GetAttributeComponentParameters<MeshGeometryAttributeLikeNode>

const definition: TemplateNodeDefinition<MeshGeometryGetAttributeComponentParameters> = {
    nodeClass: "MeshGeometryGetAttributeComponent",
    validation: {
        parameters: getAttributeComponentParametersSchema(meshGeometryAttributeLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MeshGeometryGetAttributeComponent
    extends GeometryGetAttributeComponentNode<2, MeshGeometryAttributeLikeNode>
    implements MeshGeometryAttributeLikeNode
{
    get [meshGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
